module.exports = __webpack_public_path__ + "img/citrix.0d749694.png";